import React, { useState, useEffect } from "react"
import { useForm, FormProvider } from "react-hook-form"
import Loader from "react-loader-spinner"
import GenericModal from "../generic-modal/generic-modal"
import ChangeEmailContent from "../../molecules/change-email-content/change-email-content"
import OtpModal from "../../molecules/otp-modal/otp-modal"
import StandardModal from "../standard-modal/standard-modal"
import AuthService from "../../../services/auth-service"
import "./modal-change-email.scss"

const ModalChangeEmail = ({ closeModal, logout }) => {
  const [step, setStep] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [newEmail, setNewEmail] = useState()
  const [errorOtp, setErrorOtp] = useState()
  const [resendOtp,setResendOtp] = useState(false)
  const [isDeleteActive,  setIsDeleteActive] = useState(false)
  const { ...methodsStep1 } = useForm()

  const generateAuthConfig = () => ({
    headers: {
      Authorization: JSON.parse(localStorage.getItem("TOKEN_INFO")).idToken,
    },
  })

  const getRequestChangeEmail = async () => {
    try {
      const config = generateAuthConfig()
      const res = await AuthService.getRequestEmailChange(config)
      if (res.status === 200) {
        setStep(2)
        setNewEmail(res.data.email)
        setIsDeleteActive(true)
      } else if (res.status === 400) {
        setStep(1)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const createRequestChangeEmail = async ({ email }) => {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({'event':'ga_event_consultorio','category':'Cambio Correo :: nuevo correo','action':'Click','label':'Siguiente','value':''});
      setIsLoading(true)
      const config = generateAuthConfig()
      const payload = { email }
      const res = await AuthService.createRequestEmailChange(payload, config)
      if (res.status === 200) {
        sendOtpCode(email)
        setNewEmail(email)
      } else if (res.status === 400) {
        methodsStep1.setError("email", {
          type: res.errorCode,
          message: res.userMessage,
        })
        setIsLoading(false)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const sendOtpCode = async (email, isResend = false )=> {
    try {
      const config = generateAuthConfig()
      const payload = { value: email, verificationMethod: "EMAIL" }
      const res = await AuthService.sendOTPEmailChange(payload, config)
      if (res.status === 200) {
        setStep(2)
        if(isResend){
          setResendOtp(true)
        }
      } else if (res.status === 400) {
        methodsStep1.setError("email", {
          type: res.errorCode,
          message: res.userMessage,
        })
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  const deleteRequestChangeEmail = async () => {
    try {
      const config = generateAuthConfig()
      setIsLoading(true)
      const res = await AuthService.deleteRequestEmailChange(config)
      if (res.status === 200) {
        closeModal()
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  const confirmChangeEmail = async code => {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({'event':'ga_event_consultorio','category':'Cambio Correo :: Validación nuevo correo','action':'Click','label':'{{nombre botón}}','value':''});
      setIsLoading(true)
      const config = generateAuthConfig()
      const res = await AuthService.confirmRequestEmailChange(code, {
        headers: { ...config.headers, "Content-Type": "application/json" },
      })
      if (res.status === 200) {
        setStep(3)
        window.dataLayer.push({'event':'ga_event_consultorio','category':'Cambio Correo :: Exitoso','action':'Mensaje','label':'Tus datos se han actualizado con éxito','value':''});
      } else if (res.status === 400) {
        window.dataLayer.push({'event':'ga_event_consultorio','category':'Cambio Correo :: Validación nuevo correo','action':'Mensaje','label': res.userMessage  ,'value':''});
        setErrorOtp("Código inválido")
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  const handleCloseModal = () => {
    if (step === 3) {
      logout()
    }
    closeModal()
  }

  useEffect(() => {
    getRequestChangeEmail()
  }, [])

  return (
    <GenericModal>
      <div className="f-modal-change-email">
        <button
          className="icon2-close f-close-icon"
          onClick={handleCloseModal}
        />
        {step === 0 && (
          <div className="f-loader-container">
            <Loader type="TailSpin" color="#FF409B" height={50} width={50} />
          </div>
        )}
        {step === 1 && (
          <FormProvider {...methodsStep1}>
            <ChangeEmailContent
              onSubmit={createRequestChangeEmail}
              isLoading={isLoading}
            />
          </FormProvider>
        )}
        {step === 2 && (
          <OtpModal
            title={
              isDeleteActive? "Necesitamos verificar que deseas continuar con el cambio de correo": "Necesitamos verificar"
            }
            subtitle={
              isDeleteActive? `CONFIRMA SU AÚN QUIERES CAMBIAR TU CORREO ACTUAL A ESTE NUEVO CORREO: ${newEmail}`:"QUE ERES TÚ"
            }
            
            description="Ingresa el código de 6 dígitos que hemos enviado a tu correo."
            isLoading={isLoading}
            onClickSecondary={deleteRequestChangeEmail}
            onClickNext={confirmChangeEmail}
            onSubmit={confirmChangeEmail}
            handleResendCode={() => {
              sendOtpCode(newEmail, true)
            }}
            setErrorOtp={setErrorOtp}
            errorOtp={errorOtp}
            resendOtp={resendOtp}
            setResendOtp={setResendOtp}
          />
        )}
        {step === 3 && (
          <StandardModal
            title="¡Tus datos se han actualizado con éxito!"
            description="Tu correo ha sido actualizado en nuestra base de datos. Ya puedes entrar en tu cuenta con el nuevo correo y tu misma clave"
            button_title="Perfecto"
            subtitle=""
            clickButton={handleCloseModal}
            noClose
            noLayoutModal
          />
        )}
      </div>
    </GenericModal>
  )
}

export default ModalChangeEmail
